import { Drawer, useOverlayState } from "@heroui/react";
import DesktopEditMeetsComp from "../desktop-edit-meeting-details-comp";

const EditMeetingDetailsDrawer = ({ show, record, onResp }) => {
  const state = useOverlayState({
    isOpen: show,
    onOpenChange: (isOpen) => {
      if (!isOpen) onResp?.("close", null);
    },
  });

  // Nothing to seed the form from yet.
  if (!record) return null;

  return (
    <Drawer state={state}>
      <Drawer.Backdrop variant="blur">
        <Drawer.Content placement="right">
          <Drawer.Dialog className="h-full overflow-hidden p-0 md:w-[min(520px,96vw)]">
            <DesktopEditMeetsComp
              key={record._id}
              record={record}
              onCancel={() => state.close()}
              onSaved={(updated) => {
                state.close();
                onResp?.("success", updated);
              }}
            />
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
};

export default EditMeetingDetailsDrawer;